import { CourseMenuModelService } from "./../../models/course-menu-model.service";
import { SceneStructure } from "./../../vo/scene-structure";
import { ModuleStructure } from "./../../vo/module-structure";
import { Injectable } from "@angular/core";
import { CourseStructure } from "../../vo/course-structure";
import { CustomDoc } from "../../vo/custom-doc";
import { CourseContextModelService } from "../../models/course-context-model.service";

@Injectable()
export class AppSidebarModelService {
	constructor(
		private courseContextModelService: CourseContextModelService,
		private courseMenuModelService: CourseMenuModelService
	) {}

	public get courseStructure(): CourseStructure {
		return this.courseContextModelService.courseStructure;
	}

	public get menuImages(): any {
		return this.courseMenuModelService.tileImages;
	}

	public moduleClick(selectedMod: ModuleStructure, event) {
		this.courseStructure.moduleStructures.forEach((moduleStruc) => {
			if (
				moduleStruc.courseModule.module_id ===
				selectedMod.courseModule.module_id
			) {
				if (moduleStruc.childScenes.length < 2) {
					moduleStruc.courseModule.module_selected = true;
					this.sceneClick(moduleStruc.childScenes[0]);
				} else if (!moduleStruc.courseModule.module_open) {
					moduleStruc.courseModule.module_open = true;
				} else {
					moduleStruc.courseModule.module_open = false;
				}
			} else {
				// clicked on a new module
				moduleStruc.courseModule.module_open = false;
			}
		});
	}
	public sceneClick(selectedScene: SceneStructure): void {
		//      this.closeDocs();
		this.courseStructure.moduleStructures.forEach((modStruc, modIndex) => {
			let anytrue = false;
			modStruc.childScenes.forEach((courseScen, sceneIndex) => {
				if (
					courseScen.courseScene.scene_id === selectedScene.courseScene.scene_id
				) {
					courseScen.courseScene.scene_selected = true;
					anytrue = true;
					this.courseContextModelService.updateModuleAndScene(
						modIndex,
						sceneIndex
					);
				} else {
					courseScen.courseScene.scene_selected = false;
				}
			});
			if (anytrue) {
				modStruc.courseModule.module_selected = true;
			} else {
				modStruc.courseModule.module_selected = false;
			}
		});
		// Set the current scene to the newly selected scene and go to first page
	}

	public getMenuImage(menuItemId: string): string {
		if (this.courseMenuModelService.tileImages.length > 0) {
			return this.courseMenuModelService.tileImages.find(
				(item) => item.id === menuItemId
			).image;
		} else {
			return null;
		}
	}
}
